module.exports = __webpack_public_path__ + "img/qy-fx.2e136551.svg";